<main class="main">
  <div id="lang_selector">
    <a id="es_icon" [ngClass]="{'selected': locale === 'es'}" href="/es"><img src="assets/images/es.webp" alt="es"></a>
    <a id="en_icon" [ngClass]="{'selected': locale === 'en'}" href="/en"><img src="assets/images/en.webp" alt="en"></a>
  </div>
  <app-stars-background #starCanvas class="stars_background" [numberOfStars]="300"></app-stars-background>
  <div id="background_image"></div>
  <app-home #home id="home" (device)="device"></app-home>
  <div id="scroll_to_about" class="scroll_button" (click)="scrollToSection('about')"
                                                  (keyup.enter)="scrollToSection('about')"
                                                  tabindex="0">
    <span i18n>Sobre mi</span>
    <div class="flecha"></div>
  </div>
  <app-about #about id="about" [ngClass]="{'show': showAbout}"></app-about>
  <app-works #works id="works" [ngClass]="{'show': showWorks}"></app-works>
  <app-badges #badges id="badges" [ngClass]="{'show': showBadges}"></app-badges>
  <app-contact #contact id="contact" [ngClass]="{'show': showContact}" (showTerms)="showTermsAndConditions()" (showPolicy)="showPrivacyPolicy()"></app-contact>
  <div id="scroll_to_home" class="scroll_button_inverted" (click)="scrollToSection('home')"
                                                          (keyup.enter)="scrollToSection('home')"
                                                          tabindex="0">
    <span i18n>Inicio</span>
    <div class="flecha"></div>
  </div>
</main>
<app-terms [showTerms]="showTerms" (closeTermsEvent)="closeTermsAndConditions()"></app-terms>
<app-policy [showPolicy]="showPolicy" (closePolicyEvent)="closePrivacyPolicy()"></app-policy>

<router-outlet></router-outlet>
